import Confirmation from "../components/Confirmation";
import submitted from "../assets/submitted.svg";

function RankingSubmitted() {
  return (
    <Confirmation
      title={"Ranking Sent!"}
      picture={submitted}
      firstButtonText={"Back to Book List"}
    />
  );
}

export default RankingSubmitted;
